import React from 'react'
import { Empty } from 'antd'
import ProductionMethodsHead from './ProductionMethodsTable/ProductionMethodsHead'
import ProductionMethodsRow from './ProductionMethodsTable/ProductionMethodsRow'

function ProductionMethodsTable(props) {
    const { listData, reset } = { ...props }
    return (
        <table className="table table-striped ProductionMethodsTable">
            <ProductionMethodsHead />
            <tbody>
                {listData && listData.length > 0 ? listData.map((i, index) => (
                    <ProductionMethodsRow
                        key={index}
                        item={i}
                        reset={reset}
                    />
                )) :
                    <tr>
                        <td colSpan={4}><Empty /></td>
                    </tr>}
            </tbody>
        </table>
    )
}

export default ProductionMethodsTable